import React, { useState } from 'react';
import { Card, Checkbox, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { dropdownSize, inputSize, textInputSize } from '../../Shared/UI/jsx';
import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import DevelopmentalTherapistTable from '../../Shared/UI/SelectTables/DevelopmentalTherapist'
import DTCTable from '../../Shared/UI/SelectTables/DTC';
import OccupationalTherapistTable from '../../Shared/UI/SelectTables/OccupationalTherapist';
import COTATable from '../../Shared/UI/SelectTables/COTA';
import PhysicalTherapistTable from '../../Shared/UI/SelectTables/PhysicalTherapist';
import PTATable from '../../Shared/UI/SelectTables/PTA';
import SpeechTherapistTable from '../../Shared/UI/SelectTables/SpeechTherapist';
import SLPCFTable from '../../Shared/UI/SelectTables/SLPCF';
import { FormDescription } from '../../Shared/Consts/FormDescription';
import { frequencyMinutes, frequencyOptions } from '../../Shared/Consts/Dropdowns';

const { Item } = Form;
const { TextArea } = Input;
const {Option} = Select;

const Therapists = ({ form, formContext, setFormContext }) => {
    const [developmentalTherapistIdVisible, setdevelopmentalTherapistIdVisible] = useState(false);
    const [dTCVisible, setDTCVisible] = useState(false);
    const [dTCSupervisorVisible, setDTCSupervisorVisible] = useState(false);
    const [occupationalTherapistVisible, setOccupationalTherapistVisible] = useState(false);
    const [cOTAVisible, setCOTAVisible] = useState(false);
    const [cOTASupervisorVisible, setCOTASupervisorVisible] = useState(false);
    const [physicalTherapistVisible, setPhysicalTherapistVisible] = useState(false);
    const [pTAVisible, setPTAVisible] = useState(false);
    const [pTASupervisorVisible, setPTASupervisorVisible] = useState(false);
    const [speechTherapistVisible, setSpeechTherapistVisible] = useState(false);
    const [sLPCFVisible, setSLPCFVisible] = useState(false);

    const handleDTSubmit = record => {
        setFormContext({ ...formContext, DT: record});
        form.setFieldsValue({developmentalTherapistId: record.id})
    }

    const handleDTRemove = () => {
        setFormContext({ ...formContext, DT: null});
        form.setFieldsValue({developmentalTherapistId: null});
    }

    const handleDTCSubmit = record => {
        setFormContext({ ...formContext, DTC: record, DTSupervisor: formContext.DT});
        form.setFieldsValue({dtcId: record.id, dtcSupervisorId: formContext?.DT?.id});
    }

    const handleDTCRemove = () => {
        setFormContext({ ...formContext, DTC: null, DTSupervisor: null});
        form.setFieldsValue({dtcId: null, dtcSupervisorId: null});
    }

    const handleDTSupervisorSubmit = record => {
        setFormContext({ ...formContext, DTSupervisor: record});
        form.setFieldsValue({dtcSupervisorId: record.id})
    }

    const handleDTSupervisorRemove = () => {
        setFormContext({ ...formContext, DTSupervisor: null});
        form.setFieldsValue({dtcSupervisorId: null})
    }

    const handleOTSubmit = record => {
        setFormContext({ ...formContext, OT: record});
        form.setFieldsValue({occupationalTherapistId: record.id})
    }

    const handleOTRemove = () => {
        setFormContext({ ...formContext, OT: null});
        form.setFieldsValue({occupationalTherapistId: null})
    }

    const handleCOTASubmit = record => {
        setFormContext({ ...formContext, COTA: record, COTASupervisor: formContext.OT});
        form.setFieldsValue({cotaId: record.id, cotaSupervisorId: formContext?.OT?.id});
    }

    const handleCOTARemove = () => {
        setFormContext({ ...formContext, COTA: null, COTASupervisor: null});
        form.setFieldsValue({cotaId: null, cotaSupervisorId: null});
    }

    const handleCOTASupervisorSubmit = record => {
        setFormContext({ ...formContext, COTASupervisor: record});
        form.setFieldsValue({cotaSupervisorId: record.id})
    }

    const handleCOTASupervisorRemove = () => {
        setFormContext({ ...formContext, COTASupervisor: null});
        form.setFieldsValue({cotaSupervisorId: null})
    }

    const handlePTSubmit = record => {
        setFormContext({ ...formContext, PT: record});
        form.setFieldsValue({physicalTherapistId: record.id})
    }

    const handlePTRemove = () => {
        setFormContext({ ...formContext, PT: null});
        form.setFieldsValue({physicalTherapistId: null})
    }
    
    const handlePTASubmit = record => {
        setFormContext({ ...formContext, PTA: record, PTASupervisor: formContext.PT});
        form.setFieldsValue({ptaId: record.id, ptaSupervisorId: formContext?.PT.id})
    }

    const handlePTARemove = () => {
        setFormContext({ ...formContext, PTA: null, PTASupervisor: null});
        form.setFieldsValue({ptaId: null, ptaSupervisorId: null})
    }

    const handlePTSupervisorSubmit = record => {
        setFormContext({ ...formContext, PTASupervisor: record});
        form.setFieldsValue({ptaSupervisorId: record.id})
    }

    const handlePTSupervisorRemove = () => {
        setFormContext({ ...formContext, PTASupervisor: null});
        form.setFieldsValue({ptaSupervisorId: null})
    }

    const handleSLPSubmit = record => {
        setFormContext({ ...formContext, SLP: record});
        form.setFieldsValue({speechTherapistId: record.id})
    }

    const handleSLPRemove = () => {
        setFormContext({ ...formContext, SLP: null});
        form.setFieldsValue({speechTherapistId: null})
    }

    const handleSLPCFSubmit = record => {
        setFormContext({ ...formContext, SLPCF: record, SLPCFSupervisor: formContext.SLP});
        form.setFieldsValue({slpcfId: record.id, slpcfSupervisorId: formContext?.SLP?.id})
    }

    const handleSLPCFRemove = () => {
        setFormContext({ ...formContext, SLPCF: null, SLPCFSupervisor: null});
        form.setFieldsValue({slpcfId: null, slpcfSupervisorId: null})
    }

    return (
        <Form
            form={form}
            size="small"
            layout="vertical"
        >
            <Row gutter={[8, 8]}>
                <Card title="Developmental Therapist" className='formCard'>
                    <Row>
                        {/* Developmental Therapist */}
                        <Col span={12}>
                            <Item name="dTServicesStartBy" label="DT Services Start By">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dTInitialIFSPDateSOS" label="DT Initial IFSP SOS">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dTProviderSOSDate" label="DT Provider SOS">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dTDateAssigned" label="DT Date Assigned">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dTServiceFromAnotherAgency" valuePropName="checked">
                                <Checkbox>
                                    DT Other Agency?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="developmentalTherapistId" label="Developmental Therapist">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setdevelopmentalTherapistIdVisible(!developmentalTherapistIdVisible)} />
                                            {formContext?.DT && (
                                                <CloseCircleOutlined
                                                    onClick={handleDTRemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <DevelopmentalTherapistTable visibility={developmentalTherapistIdVisible} setVisibility={setdevelopmentalTherapistIdVisible} handleSubmit={handleDTSubmit} />
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.DT && (
                                <FormDescription description={`${formContext?.DT?.preferredName ?? ""} ${formContext?.DT?.lastName ?? ""}`} />
                            )}
                        </Col>
                        <Col span={12}>
                            <Item name="dtFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dtFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dtcId" label="DTC">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setDTCVisible(!dTCVisible)} />
                                            {formContext?.DTC && (
                                                <CloseCircleOutlined
                                                    onClick={handleDTCRemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <DTCTable visibility={dTCVisible} setVisibility={setDTCVisible} handleSubmit={handleDTCSubmit} />
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.DTC && (
                                <FormDescription description={`${formContext?.DTC?.preferredName ?? ""} ${formContext?.DTC?.lastName ?? ""}`} />
                            )}
                        </Col>
                        <Col span={12}>
                            <Item name="dtcFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dtcFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dtcSupervisorId" label="DT Supervisor">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setDTCSupervisorVisible(!dTCSupervisorVisible)} />
                                            {formContext?.DTSupervisor && (
                                                <CloseCircleOutlined
                                                    onClick={handleDTSupervisorRemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <DevelopmentalTherapistTable visibility={dTCSupervisorVisible} setVisibility={setDTCSupervisorVisible} handleSubmit={handleDTSupervisorSubmit} />
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.DTSupervisor && (
                                <FormDescription description={`${formContext?.DTSupervisor?.preferredName ?? ""} ${formContext?.DTSupervisor?.lastName ?? ""}`} />
                            )}
                        </Col>
                    </Row>
                </Card>
                {/* Occupational Therapist */}
                <Card title="Occupational Therapist" className='formCard'>
                    <Row>
                        <Col span={12}>
                            <Item name="oTServicesStartBy" label="OT Services Start By">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="oTInitialIFSPDateSOS" label="OT Initial IFSP SOS">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="oTProviderSOSDate" label="OT Provider SOS">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="oTDateAssigned" label="OT Date Assigned">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="oTServiceFromAnotherAgency" valuePropName="checked">
                                <Checkbox>
                                    OT Other Agency?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="occupationalTherapistId" label="Occupational Therapist">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setOccupationalTherapistVisible(!occupationalTherapistVisible)} />
                                            {formContext?.OT && (
                                                <CloseCircleOutlined
                                                    onClick={handleOTRemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <OccupationalTherapistTable visibility={occupationalTherapistVisible} setVisibility={setOccupationalTherapistVisible} handleSubmit={handleOTSubmit} />
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.OT && (
                                <FormDescription description={`${formContext?.OT?.preferredName ?? ""} ${formContext?.OT?.lastName ?? ""}`} />
                            )}
                        </Col>
                        <Col span={12}>
                            <Item name="otFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="otFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="cotaId" label="COTA">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setCOTAVisible(!cOTAVisible)} />
                                            {formContext?.COTA && (
                                                <CloseCircleOutlined
                                                    onClick={handleCOTARemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <COTATable visibility={cOTAVisible} setVisibility={setCOTAVisible} handleSubmit={handleCOTASubmit}/>
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.COTA && (
                                <FormDescription description={`${formContext?.COTA?.preferredName ?? ""} ${formContext?.COTA?.lastName ?? ""}`} />
                            )}
                        </Col>
                        <Col span={12}>
                            <Item name="cotaFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="cotaFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="cotaSupervisorId" label="COTA Supervisor">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setCOTASupervisorVisible(!cOTASupervisorVisible)} />
                                            {formContext?.COTASupervisor && (
                                                <CloseCircleOutlined
                                                    onClick={handleCOTASupervisorRemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <OccupationalTherapistTable visibility={cOTASupervisorVisible} setVisibility={setCOTASupervisorVisible} handleSubmit={handleCOTASupervisorSubmit} />
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.COTASupervisor && (
                                <FormDescription description={`${formContext?.COTASupervisor?.preferredName ?? ""} ${formContext?.COTASupervisor?.lastName ?? ""}`} />
                            )}
                        </Col>
                    </Row>
                </Card>
                {/* Physical Therapist */}
                <Card title="Physical Therapist" className='formCard'>
                    <Row>
                        <Col span={12}>
                            <Item name="pTServicesStartBy" label="PT Services Start By">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="pTInitialIFSPDateSOS" label="PT Initial IFSP SOS">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="pTProviderSOSDate" label="PT Provider SOS">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="pTDateAssigned" label="PT Date Assigned">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="pTServiceFromAnotherAgency" valuePropName="checked">
                                <Checkbox>
                                    PT Other Agency?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="physicalTherapistId" label="Physical Therapist">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setPhysicalTherapistVisible(!physicalTherapistVisible)} />
                                            {formContext?.PT && (
                                                <CloseCircleOutlined
                                                    onClick={handlePTRemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <PhysicalTherapistTable visibility={physicalTherapistVisible} setVisibility={setPhysicalTherapistVisible} handleSubmit={handlePTSubmit} />
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.PT && (
                                <FormDescription description={`${formContext?.PT?.preferredName ?? ""} ${formContext?.PT?.lastName ?? ""}`} />
                            )}
                        </Col>
                        <Col span={12}>
                            <Item name="ptFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="ptFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="ptaId" label="PTA">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setPTAVisible(!pTAVisible)} />
                                            {formContext?.PTA && (
                                                <CloseCircleOutlined
                                                    onClick={handlePTARemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <PTATable visibility={pTAVisible} setVisibility={setPTAVisible} handleSubmit={handlePTASubmit} />
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.PTA && (
                                <FormDescription description={`${formContext?.PTA?.preferredName ?? ""} ${formContext?.PTA?.lastName ?? ""}`} />
                            )}
                        </Col>
                        <Col span={12}>
                            <Item name="ptaFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="ptaFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="ptaSupervisorId" label="PTA Supervisor">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setPTASupervisorVisible(!pTASupervisorVisible)} />
                                            {formContext?.PTASupervisor && (
                                                <CloseCircleOutlined
                                                    onClick={handlePTSupervisorRemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <PhysicalTherapistTable visibility={pTASupervisorVisible} setVisibility={setPTASupervisorVisible} handleSubmit={handlePTSupervisorSubmit}/>
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.PTASupervisor && (
                                <FormDescription description={`${formContext?.PTASupervisor?.preferredName ?? ""} ${formContext?.PTASupervisor?.lastName ?? ""}`} />
                            )}
                        </Col>
                    </Row>
                </Card>
                {/* Speech Therapist */}
                <Card title="Speech Therapist" className='formCard'>
                    <Row>
                        <Col span={12}>
                            <Item name="sTServicesStartBy" label="ST Services Start By">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="sTInitialIFSPDateSOS" label="ST Initial IFSP SOS">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="sTProviderSOSDate" label="ST Provider SOS">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="sTDateAssigned" label="ST Date Assigned">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="sTServiceFromAnotherAgency" valuePropName="checked">
                                <Checkbox>
                                    ST Other Agency?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="speechTherapistId" label="Speech Therapist">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setSpeechTherapistVisible(!speechTherapistVisible)} />
                                            {formContext?.SLP && (
                                                <CloseCircleOutlined
                                                    onClick={handleSLPRemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <SpeechTherapistTable visibility={speechTherapistVisible} setVisibility={setSpeechTherapistVisible} handleSubmit={handleSLPSubmit} />
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.SLP && (
                                <FormDescription description={`${formContext?.SLP?.preferredName ?? ""} ${formContext?.SLP?.lastName ?? ""}`} />
                            )}
                        </Col>
                        <Col span={12}>
                            <Item name="stFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="stFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="slpcfId" label="SLPCF">
                                <Input
                                    style={inputSize}
                                    addonAfter={
                                        <>
                                            <SearchOutlined onClick={() => setSLPCFVisible(!sLPCFVisible)} />
                                            {formContext?.SLPCF && (
                                                <CloseCircleOutlined
                                                    onClick={handleSLPCFRemove}
                                                    style={{ color: "red", cursor: "pointer" }}
                                                />    
                                            )}
                                            <SLPCFTable visibility={sLPCFVisible} setVisibility={setSLPCFVisible} handleSubmit={handleSLPCFSubmit} />
                                        </>
                                    }
                                />
                            </Item>
                            {formContext?.SLPCF && (
                                <FormDescription description={`${formContext?.SLPCF?.preferredName ?? ""} ${formContext?.SLPCF?.lastName ?? ""}`} />
                            )}
                        </Col>
                        <Col span={12}>
                            <Item name="slpcfFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="slpcfFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                    </Row>
                </Card>
                <Card title="Reports" className='formCard'>
                    <Row>
                        <Col span={12}>
                            <Item name="quaterlyReport5Month" label="Quarterly Report - 5 month">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="quarterlyReport10Month" label="Quarterly Report - 10 month">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="otherReport" label="Other Report">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dischargeReport" label="Discharge Report">
                                <DatePicker format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="exitSkills" label="Exit Skills">
                                <TextArea style={textInputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="notes" label="Notes">
                                <TextArea style={textInputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                        <Item name="checkNotes" valuePropName="checked">
                            <Checkbox>
                                Check Notes?
                            </Checkbox>
                        </Item>
                    </Col>
                    </Row>
                </Card>
            </Row >
        </Form >
    )
}

export default Therapists;